import React, { useState, useEffect, useRef, useMemo } from "react";
import { OmniIconComponent } from "./omni-components";

export const MenuItems = (props) => {
    const [dropdown, setDropdown] = useState(false);
    let ref = useRef();

    /* This is a React hook called `useEffect` that is used to add and remove event listeners to the
    document. It is used to close the dropdown menu when the user clicks outside of it. */
    useEffect(() => {
        const handler = (event) => {
            if (dropdown && ref.current && !ref.current.contains(event.target)) {
                setDropdown(false);
            }
        };
        document.addEventListener("mousedown", handler);
        document.addEventListener("touchstart", handler);
        return () => {
            // Cleanup the event listener
            document.removeEventListener("mousedown", handler);
            document.removeEventListener("touchstart", handler);
        };
    }, [dropdown]);

    /**
     * This is a JavaScript function that sets the state of a dropdown to true when the mouse enters a
     * certain area.
     */
    const onMouseEnter = () => {
        setDropdown(true);
    };

    /**
     * The function sets the dropdown state to false when the mouse leaves.
     */
    const onMouseLeave = () => {
        setDropdown(false);
    };

    const test = () => { }

    /**
     * The function creates a placement or package based on the event type and title, 
     * and removes the 'show' class from all dropdown containers.
     * @param event - The `event` object contains event (`event.type`) and the title of the event (`event.title`).
    */
    const create = (event) => {
        props.createProgrammaticTypes(event)
        document.querySelectorAll('.dropdown-container').forEach(function (element) {
            element.classList.remove('show');
        });
    }

    /**
     * Returns the title based on the item's type and title.
     * If the item's type is one of ['Direct', 'Programmatic', 'Social Direct', 'Social Programmatic', 'Search']
     * and the item's title is one of ['Placement', 'Line Item'], it returns 'Placement (Line Item)'.
     * Otherwise, it returns the item's title.
     * @param {Object} item - The item object.
     * @returns {string} The title of the item.
     */
    const getTitle = (item) => {

        if (['Direct', 'Programmatic', 'Search'].includes(item?.type) && item?.title === "Creative Placement") {
            return "Creative";
        }
        if (['Social Direct', 'Social Programmatic'].includes(item?.type) && item?.title === "Creative Placement") {
            return "Creative  (Ad Name)";
        }
        if (['Social Direct', 'Social Programmatic'].includes(item?.type) && ['Line Item'].includes(item?.title)) {
            return 'Line Item (Ad Set)';
        }
        return item?.title;
    }

    return (
        <>
        <div  slot = {props.slot ? props.slot : 'invoker'} className={`menu-items ${props.depthLevel === 0 ? "create-button-container" : ""} ${props.disabled ? 'disabled' : ''}` } ref={ref} onMouseEnter={props.depthLevel !== 0 ? onMouseEnter : test} onMouseLeave={props.depthLevel !== 0 ? onMouseLeave : test}>
            {props.items.submenu ? (
                <>
                    <button aria-haspopup="menu"
                        disabled={props.disabled ? props.disabled : false}
                        className={`${props.depthLevel === 0 ? "secondary" : "create-button-content"}`}
                        id={`${props.depthLevel === 0 ? "create-button" : ""}`}
                        aria-expanded={dropdown ? "true" : "false"}
                        onClick={() => setDropdown((prev) => !prev)}>
                        {props.items.title}{' '}
                        {props.depthLevel > 0 ? <OmniIconComponent className="is-size-4 settingsIcon" icon-id="omni:interactive:right"></OmniIconComponent> : ''}
                    </button>
                    <Dropdown depthLevel={props.depthLevel} submenus={props.items.submenu} dropdown={dropdown} createPackage={props.createPackage} createPlacement={props.createPlacement} createDirectCreativePlacement={props.createDirectCreativePlacement} createProgrammaticTypes={props.createProgrammaticTypes} disabled={props.disabled} />
                </>
            ) : (
                <span onClick={() => create(props.items)}>{getTitle(props.items)}</span>
            )}
            {props.items.separator ? <hr className="menu-separator" /> : ""}
        </div>
        </>
    );
};

export const Dropdown = ({ submenus, dropdown, depthLevel, createPackage, createPlacement, createDirectCreativePlacement, createProgrammaticTypes }) => {
    depthLevel = depthLevel + 1;
    const dropdownClass = depthLevel > 1 ? "dropdown-submenu" : "";
    const fixedClass = depthLevel === 1 ? "fixed-dropdown" : "";
    return (
        <>
            <div className={`dropdown-container ${dropdownClass} ${fixedClass} ${dropdown ? "show" : ""}`} id={`${fixedClass}`}>
                {submenus.map((submenu, index) => (
                    <MenuItems items={submenu} key={index} depthLevel={depthLevel} createPackage={createPackage} createPlacement={createPlacement} createProgrammaticTypes={createProgrammaticTypes} disabled={submenu.disabled} createDirectCreativePlacement={createDirectCreativePlacement}/>
                ))}
            </div>
        </>
    );
}